import { useQuery } from '@tanstack/react-query'
import { useNavigate, useParams } from 'react-router'
import { api } from '../api/client'
import type { Erfassung } from '../api/typen'
import AppRahmen from '../komponenten/AppRahmen'
import StuecklisteInhalt from '../komponenten/StuecklisteInhalt'

/**
 * Schritt 10: aggregierte Stueckliste als Grundlage fuer Bestellung und Kundenangebot (P10-01),
 * dazu der strukturierte Export (P10-02). Der Inhalt ist dasselbe Bauteil wie im Buero.
 */
export default function Ergebnis() {
  const { erfassungId } = useParams()
  const navigiere = useNavigate()

  const erfassung = useQuery({
    queryKey: ['erfassung-kurz', erfassungId],
    queryFn: () => api.get<Erfassung>(`/api/erfassungen/${erfassungId}/kurz`),
  })

  return (
    <AppRahmen
      titel="Ergebnis"
      unter="Stückliste und Export"
      zurueck={`/erfassungen/${erfassungId}`}
      pfad={
        erfassung.data
          ? {
              erfassungId: erfassung.data.id,
              standort: erfassung.data.standort,
              versorgungspunktId: null,
              versorgungspunkt: null,
              schrankId: null,
              schrank: null,
            }
          : undefined
      }
      ebene="erfassung"
      pfadZusatz="Ergebnis"
      menue={[
        {
          beschriftung: 'Verifizierungsreport',
          beiKlick: () => navigiere(`/erfassungen/${erfassungId}/report`),
        },
      ]}
      fuss={
        <button
          className="btn btn-primaer"
          onClick={() => window.open(`/api/erfassungen/${erfassungId}/export`, '_blank')}
        >
          JSON-Export herunterladen
        </button>
      }
    >
      <StuecklisteInhalt erfassungId={erfassungId!} />
    </AppRahmen>
  )
}
